/**
 * Social Proof Notification Widget
 * Displays rotating purchase notifications with slide animations
 */

class SocialProofWidget {
  constructor() {
    this.config = window.socialProofConfig || {};
    this.widget = document.getElementById('socialProofWidget');
    this.currentIndex = 0;
    this.isVisible = false;
    this.isPaused = false;
    this.cycleTimeout = null;
    this.hideTimeout = null;
    
    if (!this.config.enabled || !this.widget || !this.config.reviews || this.config.reviews.length === 0) {
      return;
    }
    
    this.init();
  }
  
  init() {
    // Set position class
    this.widget.classList.add(this.config.position || 'bottom-left');
    
    // Bind elements
    this.elements = {
      image: this.widget.querySelector('.social-proof-product-img'),
      customer: this.widget.querySelector('.social-proof-customer'),
      location: this.widget.querySelector('.social-proof-location'),
      productName: this.widget.querySelector('.social-proof-product-name'),
      time: this.widget.querySelector('.social-proof-time'),
      closeBtn: this.widget.querySelector('.social-proof-close'),
      link: this.widget.querySelector('.social-proof-link')
    };
    
    // Event listeners
    this.elements.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
    });
    this.widget.addEventListener('mouseenter', () => this.pause());
    this.widget.addEventListener('mouseleave', () => this.resume());
    
    // Check if user has closed widget in this session
    if (sessionStorage.getItem('socialProofClosed') === 'true') {
      return;
    }
    
    // Start the cycle after initial delay
    setTimeout(() => this.startCycle(), 3000);
  }
  
  startCycle() {
    if (this.config.reviews.length === 0) return;
    
    this.showReview(this.currentIndex);
    this.scheduleNext();
  }
  
  showReview(index) {
    if (this.isPaused || !this.config.reviews[index]) return;
    
    const review = this.config.reviews[index];
    
    // Update content
    this.elements.image.src = review.productImage || '';
    this.elements.image.alt = review.productName || 'Product';
    this.elements.customer.textContent = review.customerName || 'Someone';
    this.elements.location.textContent = review.city || 'Unknown';
    this.elements.productName.textContent = review.productName || 'a product';
    this.elements.time.textContent = review.timeAgo || 'recently';
    
    // Update link
    if (review.productUrl && review.productUrl !== '#') {
      this.elements.link.href = review.productUrl;
      this.elements.link.style.cursor = 'pointer';
    } else {
      this.elements.link.href = '#';
      this.elements.link.style.cursor = 'default';
      this.elements.link.onclick = (e) => e.preventDefault();
    }
    
    // Show widget with animation
    this.widget.classList.remove('slide-out');
    this.widget.classList.add('active');
    this.isVisible = true;
    
    // Schedule hide
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, this.config.displayDuration || 5000);
  }
  
  hide() {
    if (!this.isVisible) return;
    
    this.widget.classList.remove('active');
    this.widget.classList.add('slide-out');
    this.isVisible = false;
    
    clearTimeout(this.hideTimeout);
  }
  
  scheduleNext() {
    clearTimeout(this.cycleTimeout);
    
    const totalDuration = (this.config.displayDuration || 5000) + (this.config.intervalBetween || 2000);
    
    this.cycleTimeout = setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % this.config.reviews.length;
      this.showReview(this.currentIndex);
      this.scheduleNext();
    }, totalDuration);
  }
  
  pause() {
    this.isPaused = true;
    clearTimeout(this.hideTimeout);
    clearTimeout(this.cycleTimeout);
  }
  
  resume() {
    this.isPaused = false;
    
    if (this.isVisible) {
      // Resume hide timeout
      this.hideTimeout = setTimeout(() => {
        this.hide();
      }, 2000);
    }
    
    this.scheduleNext();
  }
  
  destroy() {
    clearTimeout(this.cycleTimeout);
    clearTimeout(this.hideTimeout);
    if (this.widget) {
      this.widget.remove();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SocialProofWidget();
  });
} else {
  new SocialProofWidget();
}

// Handle close button - store in session
document.addEventListener('click', (e) => {
  if (e.target.closest('.social-proof-close')) {
    sessionStorage.setItem('socialProofClosed', 'true');
  }
});
